/** Turnos que un SVC admite. Espejo de availabilityDays. */
export const DEFAULT_AVAILABILITY_SHIFTS: string[] = ["AM", "PM"];

export const resolveAvailabilityShifts = (raw?: string[] | null): string[] => {
  if (!raw || raw.length === 0) return [...DEFAULT_AVAILABILITY_SHIFTS];
  const present = new Set(raw.filter((s) => DEFAULT_AVAILABILITY_SHIFTS.includes(s)));
  const ordered = DEFAULT_AVAILABILITY_SHIFTS.filter((s) => present.has(s));
  return ordered.length > 0 ? ordered : [...DEFAULT_AVAILABILITY_SHIFTS];
};

/** Unión ordenada de los turnos habilitados de todos los SVCs del chofer. Sin SVCs → default. */
export const getAllowedShiftsUnion = (
  svcs: { availabilityShifts?: string[] | null }[]
): string[] => {
  if (svcs.length === 0) return [...DEFAULT_AVAILABILITY_SHIFTS];
  const set = new Set<string>();
  for (const s of svcs) for (const sh of resolveAvailabilityShifts(s.availabilityShifts)) set.add(sh);
  return DEFAULT_AVAILABILITY_SHIFTS.filter((s) => set.has(s));
};
